// URL <-> comparison-selection codec. The selection keys on the server
// forecastId (= forecasts.id). See design doc D2.

// Root ids are comma-free (forecastId UUIDs / "fc-…" client ids), so the param
// value is a plain comma-joined list and `URLSearchParams` is the SINGLE
// encode/decode layer. Do NOT percent-encode per id here — that would
// double-encode once it goes through URLSearchParams (e.g. %20 -> %2520).

// 2+ ids -> "id0,id1" (id0 is the focused lane). Fewer than 2 -> "" (no param).
export function encodeCompareParam(rootIds) {
  if (!rootIds || rootIds.length < 2) return "";
  return rootIds.join(",");
}

export function decodeCompareParam(value) {
  if (!value) return [];
  const seen = new Set();
  const out = [];
  for (const s of value.split(",")) {
    const id = s.trim();
    if (id && !seen.has(id)) {
      seen.add(id);
      out.push(id);
    }
  }
  return out;
}

export function readCompareFromSearch(search) {
  return decodeCompareParam(new URLSearchParams(search || "").get("compare"));
}

// Returns a new search string ("?..." or "") with `compare` set/cleared,
// leaving other params untouched.
export function writeCompareToSearch(search, rootIds) {
  const p = new URLSearchParams(search || "");
  const enc = encodeCompareParam(rootIds);
  if (enc) p.set("compare", enc);
  else p.delete("compare");
  const s = p.toString();
  return s ? `?${s}` : "";
}

// Keep only ids that resolve to a loaded forecast (by server forecastId,
// falling back to client id). Canonicalizes each kept id to the forecast's
// persisted server forecastId (preferred) or client id, so downstream callers
// (loadMessages, dedup) always work on the server key. Reports dropped ids for
// a non-blocking notice.
export function resolveSelection(rootIds, forecasts) {
  const list = Array.isArray(forecasts) ? forecasts : [];
  const kept = [];
  const dropped = [];
  const seen = new Set();
  for (const rid of rootIds || []) {
    const f = list.find((x) => x.forecastId === rid || x.id === rid);
    if (!f) {
      dropped.push(rid);
      continue;
    }
    const canonical = f.forecastId || f.id; // prefer the persisted server id
    if (!seen.has(canonical)) {
      seen.add(canonical);
      kept.push(canonical);
    }
  }
  return { rootIds: kept, dropped };
}
